<div class="LesitungEdit row" *ngIf="Entry && Entry != null">
  <div class="row">
    <div class="row">
      <div class="col edit">
        <div class="row">
          <div class="col">
            <div class="col">
              <AdminCard [Item]="Entry" HeaderText="Stammdaten">
                <div class="row">
                  <div class="col">
                    <div class="form-floating mb-3">
                      <input type="text" class="form-control" id="name" [(ngModel)]="Entry.stammdaten.name">
                      <label for="name">Bezeichnung</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="form-floating mb-3">
                      <input type="text" class="form-control" id="ik" [(ngModel)]="Entry.stammdaten.ik">
                      <label for="ik">IK</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="form-floating mb-3">
                      <input type="text" class="form-control" id="mail" [(ngModel)]="Entry.stammdaten.mail">
                      <label for="mail">E-Mail</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="form-floating mb-3">
                      <input type="text" class="form-control" id="telefone" [(ngModel)]="Entry.stammdaten.telefone">
                      <label for="telefone">Telefone</label>
                    </div>
                  </div>
                </div>
                <Address [(address)]="Entry.stammdaten.adresse"></Address>
                <div class="form-floating mb-3">
                  <select class="form-select"
                          id="leistung"
                          [(ngModel)]="Entry.leistung">

                    <option *ngFor="let Entry of LeistungList" [ngValue]="Entry">
                      {{ Entry.name }}
                    </option>
                  </select>
                  <label for="leistung">Leistung</label>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="form-floating mb-3">
                      <input type="text" class="form-control" id="iban" [(ngModel)]="Entry.stammdaten.iban">
                      <label for="iban">IBAN</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="form-floating mb-3">
                      <input type="text" class="form-control" id="kuertzel" [(ngModel)]="Entry.stammdaten.kuertzel">
                      <label for="kuertzel">Kürtzel</label>
                    </div>
                  </div>
                </div>
                <div class="form-check mb-3">
                  <input name="leistungserbrinnger" id="leistungserbrinnger" class="form-check-input" type="checkbox"
                         [checked]="Entry.stammdaten.leistungserbrinnger"
                         (change)="Entry.stammdaten.leistungserbrinnger = !Entry.stammdaten.leistungserbrinnger " />
                  <label for="leistungserbrinnger" class="form-check-label">Leistungserbrinnger</label>
                </div>
                <div class="form-check mb-3">
                  <input name="enableAutosetStatus1" id="enableAutosetStatus1" class="form-check-input" type="checkbox"
                         [checked]="Entry.stammdaten.enableAutosetStatus1"
                         (change)="Entry.stammdaten.enableAutosetStatus1 = !Entry.stammdaten.enableAutosetStatus1 " />
                  <label for="enableAutosetStatus1" class="form-check-label">Automatisches zuweisen von status 1</label>
                </div>
                <div class="form-check mb-3">
                  <input name="autoInKlaerung" id="autoInKlaerung" class="form-check-input" type="checkbox"
                         [checked]="Entry.autoInKlaerung"
                         (change)="Entry.autoInKlaerung = !Entry.autoInKlaerung" />
                  <label for="autoInKlaerung" class="form-check-label">
                    Auto in Klärung
                  </label>
                </div>
                <div class="form-check mb-3">
                  <input name="leadsAccount" id="leadsAccount" class="form-check-input" type="checkbox"
                         [checked]="Entry.leadsAccount"
                         (change)="Entry.leadsAccount = !Entry.leadsAccount" />
                  <label for="leadsAccount" class="form-check-label">
                    Is Leads Account
                  </label>
                </div>
                <div class="form-check mb-3">
                  <input name="onlyParcelMode" id="onlyParcelMode" class="form-check-input" type="checkbox"
                         [checked]="Entry.onlyParcelMode"
                         (change)="Entry.onlyParcelMode = !Entry.onlyParcelMode" />
                  <label for="onlyParcelMode" class="form-check-label">
                    Nur Versand (Modus)
                  </label>
                </div>
              </AdminCard>
            </div>
            <div class="col">
              <AdminCard [Item]="Entry" HeaderText="Leitstelle">
                <div class="row">
                  <div class="col">
                    <div class="form-floating mb-3">
                      <input type="text" class="form-control" id="leitstelleKundennummer" [(ngModel)]="Entry.leitstelleKundennummer">
                      <label for="leitstelleKundennummer">Leitstelle Kundennummer</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="form-floating mb-3">
                      <input type="text" class="form-control" id="sosSource" [(ngModel)]="Entry.sosSource">
                      <label for="sosSource">SOS Name</label>
                    </div>
                  </div>
                </div>
              </AdminCard>
              <AdminCard [Item]="Entry" HeaderText="Abrechnungszentrum">
                <div class="form-floating mb-3">
                  <select class="form-select"
                          id="abrechnungszentrum"
                          [(ngModel)]="Entry.abrechnungszentrum.abrechnungszentrum">

                    <option *ngFor="let Entry of Abbrechnungcentren" [ngValue]="Entry.Key">
                      {{ Entry.Value }}
                    </option>
                  </select>
                  <label for="abrechnungszentrum">Abrechnungszentrum</label>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="form-floating mb-3">
                      <input type="text" class="form-control" id="idAbrechnungszentrum" [(ngModel)]="Entry.abrechnungszentrum.idAbrechnungszentrum">
                      <label for="idAbrechnungszentrum">Abrechnungszentrum ID</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="form-floating mb-3">
                      <input type="text" class="form-control" id="transferUrl" [(ngModel)]="Entry.abrechnungszentrum.transferUrl">
                      <label for="transferUrl">Transfer Url</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="form-floating mb-3">
                      <input type="text" class="form-control" id="transferPath" [(ngModel)]="Entry.abrechnungszentrum.transferPath">
                      <label for="transferPath">Transfer Pfad</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="form-floating mb-3">
                      <input type="text" class="form-control" id="transferPort" [(ngModel)]="Entry.abrechnungszentrum.transferPort">
                      <label for="transferPort">Transfer Port</label>
                    </div>
                  </div>
                </div>
                <div class="form-check mb-3">
                  <input name="gkvOnly" id="gkvOnly" class="form-check-input" type="checkbox"
                         [checked]="Entry.abrechnungszentrum.gkvOnly"
                         (change)="Entry.abrechnungszentrum.gkvOnly = !Entry.abrechnungszentrum.gkvOnly" />
                  <label for="gkvOnly" class="form-check-label">
                    Nur GKV
                  </label>
                </div>
                <div class="form-check mb-3">
                  <input name="transferUseSSH" id="transferUseSSH" class="form-check-input" type="checkbox"
                         [checked]="Entry.abrechnungszentrum.transferUseSSH"
                         (change)="Entry.abrechnungszentrum.transferUseSSH = !Entry.abrechnungszentrum.transferUseSSH" />
                  <label for="transferUseSSH" class="form-check-label">
                    sFTP (over SSH)
                  </label>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="form-floating mb-3">
                      <input type="text" class="form-control" id="transferUser" [(ngModel)]="Entry.abrechnungszentrum.transferUser">
                      <label for="transferUser">Transfer User</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="form-floating mb-3">
                      <input type="text" class="form-control" id="transferPassword" [(ngModel)]="Entry.abrechnungszentrum.transferPassword">
                      <label for="transferPassword">Transfer Password</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="form-floating mb-3">
                      <input type="text" class="form-control" id="transferReciverMail" [(ngModel)]="Entry.abrechnungszentrum.transferReciverMail">
                      <label for="transferReciverMail">TransferReciver Mail</label>
                    </div>
                  </div>
                </div>
              </AdminCard>
          </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <AdminCard [Item]="Entry" HeaderText="LEGS">
              <table class="table table-striped">

                <thead>
                  <tr>
                    <th scope="col">PG</th>
                    <th scope="col">LEGS</th>
                    <th scope="col" width="100" style="text-align:center"><i class="btn btn-success btn-sm bi bi-person-plus" (click)="AddUpdateLegs(null)" ></i></th>
                  </tr>
                </thead>
                <tbody>
                  @for (legs of CurrentLegs; track legs.key; let i = $index) {
                  <tr>
                    <td>
                      {{ legs.pg }}
                    </td>
                    <td>
                      {{ legs.legs }}
                    </td>
                    <td style="text-align:center">
                      <i class="btn btn-primary btn-sm bi bi-pen m-1" (click)="AddUpdateLegs(legs)"></i>
                      <i class="btn btn-danger btn-sm bi bi-clock-history m-1" title="Historie" (click)="OpenLegsHistory(legs.pg)"></i>
                    </td>
                  </tr>
                  }
                </tbody>
              </table>
            </AdminCard>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <AdminCard [Item]="Entry" HeaderText="Geräte">
              <label>Zugriff auf Geräte</label>

              <div class="select-list">
                <!-- Filtern: Nur Partner anzeigen, deren Key nicht der currentInputId entspricht -->
                <ng-container *ngFor="let partner of Partner">
                  <div class="form-check" *ngIf="partner.key !== Entry.key">

                    <input type="checkbox"
                           class="form-check-input zuzalungBtn"
                           [id]="'partner-' + partner.key"
                           [checked]="isChecked(partner.key)"
                           (change)="onCheckboxChange($event, partner.key)" />

                    <label class="form-check-label" [for]="'partner-' + partner.key">
                      {{ partner.stammdaten.name }}
                    </label>

                  </div>
                </ng-container>
              </div>
            </AdminCard>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <AdminCard [Item]="Entry" HeaderText="eKV">
              <div class="form-check mb-3">
                <input name="useMIP" id="useMIP" class="form-check-input" type="checkbox"
                       [checked]="Entry.ekv.useMIP"
                       (change)="Entry.ekv.useMIP = !Entry.ekv.useMIP" />
                <label for="useMIP" class="form-check-label">Akiviere MIP</label>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-floating mb-3">
                    <input type="text" class="form-control" id="md5key" [(ngModel)]="Entry.ekv.md5key">
                    <label for="md5key">md5key</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-floating mb-3">
                    <input type="text" class="form-control" id="softwareID" [(ngModel)]="Entry.ekv.softwareID">
                    <label for="softwareID">softwareID</label>
                  </div>
                </div>
              </div>

            </AdminCard>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <AdminCard [Item]="Entry" HeaderText="Abteilungen">
              <div class="Abteilungen">
                <div class="Header row">
                  <div class="col">Name</div>
                  <div class="col-auto"><div class="btn btn-success" (click)="AddNewAbteilung()"><i class="fas fa-plus"></i></div></div>
                </div>
                @for (abteilung of Entry.abteilungen; track abteilung.key)
                {
                  <div class="Item row">
                    <div class="col">{{abteilung.name}}</div>
                    <div class="col-auto"></div>
                  </div>
                }
              </div>
            </AdminCard>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row Button">
  <div class="col"></div>
  <div class="col-auto">
    <div class="btn btn-success" (click)="SaveData()">Speichern</div>
  </div>
</div>
<ng-template #successTpl> Speichern erfolgreich! </ng-template>
